import React from 'react';
import '../Assets/Additionalcss/Button.css'


function Button({title,style}) {
    return (
        <input className={style} type="button" value={title} />
    );
}
export default Button;